import styled from "@emotion/styled";
import { compassColors } from "src/utils/styling";
import {
  breakpointMobileOnly,
  breakpointWideDesktopOnly,
} from "src/design-system/styles/breakpoints";
import { fontTitle, fontP2Regular } from "src/design-system/styles/fonts";

export const Box = styled.div`
  background: ${compassColors.offWhite};
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  padding: 50px 16px 50px;
  @media ${breakpointWideDesktopOnly} {
    padding: 50px 90px;
  }
  @media ${breakpointMobileOnly} {
    padding: 35px 16px 35px;
  }
`;

export const BoxSection = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  justify-content: space-around;
  max-width: 400px;
  margin: 0 auto;
  @media ${breakpointWideDesktopOnly} {
    flex-direction: row;
    max-width: none;
  }
`;

export const CTASection = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  padding-top: 32px;
`;

export const Section = styled.div`
  text-align: center;
  align-items: center;
  width: 100%;
  margin-bottom: 50px;

  &:last-child {
    margin-bottom: 18px;
  }

  @media ${breakpointWideDesktopOnly} {
    width: 30%;
    margin-bottom: 18px;
  }
`;

export const Icon = styled.img`
  width: 38px;
  @media ${breakpointWideDesktopOnly} {
    margin-top: 2px;
  }
`;

const PageText = styled.div`
  display: block;
  margin: 0 20px;
`;

export const Title = styled(PageText)`
  ${fontTitle};
  font-weight: 700;
  font-size: 18px;
  margin: 16px 0;
`;

export const Content = styled(PageText)`
  ${fontP2Regular};
`;
